//import ActionClienteSet from "../ActionClienteSet";
//import { TipoDeCliente, TipoDeDoc, Sexo } from "../../../../isp.žapi.clientes/constantesApiClientes";

import ActionTypeCliente from "../ActionTypeCliente";


export default class SeleccionarContacto extends ActionTypeCliente{

    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.sensorSeleccionDeValorDeLista=!estado.flag.sensorSeleccionDeValorDeLista;

        // nuevoEstado.flag.procesandoComando = false;
        let indexValorDeListaSeleccionado = estado.domain.screen.contactos.listaNombres.findIndex((nombreDeLista) => nombreDeLista.sec===this.payload.sec);
        
        //Se seleccionó el Contacto Por Definir, el ultimo elemento de la Lista de Nombres (Viene a ser el ultimo "Definir Nuevo")
        const ultimoIndice = estado.domain.screen.contactos.listaNombres.length-1;
        if(indexValorDeListaSeleccionado===ultimoIndice){
            
            const contactoPorDefinir = estado.domain.screen.contactos.contactoPorDefinir;
            const nuevosAtributos = nuevoEstado.domain.screen.contactos.atributos;
            nuevosAtributos.nombre  =contactoPorDefinir.nombre;
            nuevosAtributos.rol     =contactoPorDefinir.rol;
            nuevosAtributos.telcel1 =contactoPorDefinir.telcel1;
            nuevosAtributos.telcel2 =contactoPorDefinir.telcel2;
            nuevosAtributos.telfijo =contactoPorDefinir.telfijo;
            nuevosAtributos.email   =contactoPorDefinir.email;
            // nuevoEstado.domain.screen.contactos.valorListaNombres = {nombre:contactoPorDefinir.nombre}
            /* nuevoEstado.domain.screen.contactos.valorListaNombres = {
                sec: estado.domain.screen.contactos.valorListaNombres.sec ,
                nombre : contactoPorDefinir.nombre
            }; */
            // const ultimoIndice = estado.domain.screen.contactos.listaNombres.length-1;
            const listaNombres = estado.domain.screen.contactos.listaNombres;
            // nuevoEstado.domain.screen.contactos.listaNombres = listaNombres;
            nuevoEstado.domain.screen.contactos.valorListaNombres.sec = listaNombres[indexValorDeListaSeleccionado].sec;
            nuevoEstado.domain.screen.contactos.valorListaNombres.nombre = listaNombres[indexValorDeListaSeleccionado].nombre;
            nuevoEstado.domain.screen.contactos.indexSeleccionado = indexValorDeListaSeleccionado;

            return nuevoEstado
        }

        
        
        //Se seleccionó a "Definir Nuevo"
        /* if(indexSeleccionado >= estado.domain.screen.contactos.data.length){
            const contactoPorDefinir = estado.domain.screen.contactos.contactoPorDefinir;
            const atributos = nuevoEstado.domain.screen.contactos.atributos;
            atributos.nombre  =contactoPorDefinir.nombre;
            atributos.rol     =contactoPorDefinir.rol;
            atributos.telcel1 =contactoPorDefinir.telcel1;
            atributos.telcel2 =contactoPorDefinir.telcel2;
            atributos.telfijo =contactoPorDefinir.telfijo;
            atributos.email   =contactoPorDefinir.email;
            // nuevoEstado.domain.screen.contactos.valorListaNombres = {nombre:atributos.nombre}
            nuevoEstado.domain.screen.contactos.valorListaNombres.nombre = atributos.nombre;
            return nuevoEstado
        } */

        //Se seleccionó un contacto definido
        const contactoSeleccionado = estado.domain.screen.contactos.data[indexValorDeListaSeleccionado];
        const nuevosAtributos   =nuevoEstado.domain.screen.contactos.atributos;
        nuevosAtributos.nombre  =contactoSeleccionado.nombre;
        nuevosAtributos.rol     =contactoSeleccionado.rol;
        nuevosAtributos.telcel1 =contactoSeleccionado.telcel1;
        nuevosAtributos.telcel2 =contactoSeleccionado.telcel2;
        nuevosAtributos.telfijo =contactoSeleccionado.telfijo;
        nuevosAtributos.email   =contactoSeleccionado.email;

        const listaNombres = estado.domain.screen.contactos.listaNombres;
        nuevoEstado.domain.screen.contactos.listaNombres = listaNombres;
        // nuevoEstado.domain.screen.contactos.valorListaNombres.sec = listaNombres[indexContactoSeleccionado].sec;
        // nuevoEstado.domain.screen.contactos.valorListaNombres.nombre = listaNombres[indexContactoSeleccionado].nombre;
        nuevoEstado.domain.screen.contactos.valorListaNombres={
            nombre: listaNombres[indexValorDeListaSeleccionado].nombre,
            sec: listaNombres[indexValorDeListaSeleccionado].sec,
        }
            
        // const indexSeleccionado = this.payload;
        nuevoEstado.domain.screen.contactos.indexSeleccionado = indexValorDeListaSeleccionado;
        // nuevoEstado.domain.screen.contactos.valorListaNombres = {nombre:atributos.nombre}

        return nuevoEstado;
    }

}